<template>
  <div class="content-box">
    <div class="content">
      <div class="policylib-result express">
        <el-tabs v-model="activeName">
          <el-tab-pane label="我发布的成果列表" name="first">
            <!-- 筛选 -->
            <div class="filters-list">
              <ul class="filters">
                <li
                  class="fitler-item"
                  v-for="(fitler, goodsIndex) in fitlerList"
                  :key="goodsIndex"
                >
                  <span class="nameFrame">{{ fitler.title }}</span>
                  <ul class="cates">
                    <li
                      :class="{
                        active: typeIndex === fitler.index,
                      }"
                      v-for="(type, typeIndex) in fitler.typeList"
                      :key="type.id"
                      @click="handleclick(typeIndex, fitler, type, goodsIndex)"
                    >
                      {{ type.name }}
                    </li>
                  </ul>
                </li>
              </ul>
              <!-- 已经选择： -->
              <ul class="filters">
                <li class="fitler-item">
                  <span class="nameFrame">已经选择：</span>
                  <ul class="cates">
                    <li
                      class="filtered-item"
                      v-for="(sureItem, index) in FilterList"
                      :key="index"
                    >
                      {{ sureItem.name }}
                      <i class="el-icon-close" @click="minItemClick(index)"></i>
                    </li>

                    <li class="clear-all-filtered" @click="resetClick">
                      清除筛选
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <!-- 表格 -->
            <div class="table">
              <div class="header">
                <span
                  :class="idx == index ? 'contrast' : ''"
                  @click="Csort(i, idx)"
                  v-for="(i, idx) in sort"
                  :key="idx"
                >
                  {{ i }}
                </span>
              </div>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column label="成果名称" align="center">
                  <template slot-scope="scope">
                    <p @click="handleXq(scope.$index, scope.row)">
                      {{ scope.row.name }}
                    </p>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="work"
                  label="所属单位"
                 
                  align="center"
                >
                </el-table-column>
                <el-table-column label="发布时间" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.created_at">
                      {{ scope.row.created_at | formatDate }}
                    </span>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="maturity.name"
                  label="技术成熟度"
                 
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="hmethod.name"
                  label="合作方式"
                  
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="holder"
                  label="现有持有人"
                    align="center"
                >
                </el-table-column>
              </el-table>

              <div class="pagination">
                <pagination
                  style="padding: 0"
                  class="pages"
                  v-show="total > 0"
                  :total="total"
                  layout="total,  prev, pager, next, jumper"
                  :page.sync="listQuery.page"
                  :limit.sync="listQuery.limit"
                  @pagination="getList"
                />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog
      class="dialog"
      :visible.sync="dia.dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <Xq :item="dia"></Xq>
    </el-dialog>
  </div>
</template>

<script>
import {
  AchievementsLists,
  Territory,
  Maturity,
  Hmethodad,
} from "@/common/js/api";
import { formatDate } from "../../../common/js/times"; //时间
import Pagination from "@/common/Pagination";
import Xq from "./xq/test1-3";

export default {
  components: { Pagination, Xq },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
  },
  data() {
    return {
      activeName: "first",
      fitlerList: [
        {
          title: "按 领 域 ：",
          typeList: [],
        },
        {
          title: "成  熟  度 ：",
          typeList: [],
        },
        {
          title: "合作方式：",
          typeList: [],
        },
      ], //筛选
      FilterList: {
        0: { name: "全部" },
        1: { name: "全部" },
        2: { name: "全部" },
      }, //已经选择数据
      FilterListID: {}, //已经选择数据id
      sort: ["综合排序", "发布时间"],
      index: 0,
      total: 0, //总条目数
      listQuery: {
        limit: 10,
        page: 1,
      },
      input3: "",
      tableData: [],
      dia: {
        dialogVisible: false,
        id: "",
      },
      all: 1,
      created_at: "",
    };
  },
  created() {
    this.getList();
    this.getTerritory();
    this.getMaturity();
    this.getHmethodad();
    this.fitlerList.forEach((item) => this.$set(item, "index", 0));
  },
  methods: {
    // 详情
    handleXq(index, row) {
      this.dia.dialogVisible = true;
      this.dia.id = row.id;
    },
    // 列表
    getList() {
      this.getAchievementsLists(this.FilterListID);
    },
    // 筛选
    handleclick(typeIndex, goods, type, goodsIndex) {
      goods.index = typeIndex;

      this.$set(this.FilterList, goodsIndex, type);
      this.$set(this.FilterListID, goodsIndex, type.id);
      this.getAchievementsLists(this.FilterListID);
    },
    // 已选择每项的x键
    minItemClick(minIndex) {
      this.$delete(this.FilterList, minIndex);
      this.$delete(this.FilterListID, minIndex);
      this.fitlerList[minIndex].index = 0;
      this.getAchievementsLists(this.FilterListID);
    },
    /* 清除筛选 */
    resetClick() {
      for (var i in this.fitlerList) {
        this.fitlerList[i].index = 0;
      }
      this.FilterList = {};
      this.FilterListID = {};
      this.getAchievementsLists(this.FilterListID);
    },

    getAchievementsLists(FilterListID) {
      var data = {
        hmethod: FilterListID[2],
        maturity: FilterListID[1],
        territory: FilterListID[0],
        member_id: JSON.parse(localStorage.getItem("user")).id,
        page: this.listQuery.page,
        limits: this.listQuery.limit,
        all: this.all,
        created_at: this.created_at,
      };
      AchievementsLists(data)
        .then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        })
        .catch(() => {});
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 排序
    Csort(item, idx) {
      this.index = idx;
      console.log(this.index);
      if (this.index == 0) {
        this.all = 1;
        this.created_at = "";
      } else if (this.index == 1) {
        this.all = "";
        this.created_at = 2;
      }
      this.getList(this.FilterListId);
    },
    // 领域
    getTerritory() {
      Territory()
        .then((res) => {
          var b = { name: "全部" };
          res.data.unshift(b);
          this.fitlerList[0].typeList = res.data;
        })
        .catch(() => {});
    },
    // 技术成熟度
    getMaturity() {
      Maturity()
        .then((res) => {
          var b = { name: "全部" };
          res.data.unshift(b);
          this.fitlerList[1].typeList = res.data;
        })
        .catch(() => {});
    },
    // 合作方式
    getHmethodad() {
      Hmethodad()
        .then((res) => {
          var b = { name: "全部" };
          res.data.unshift(b);
          this.fitlerList[2].typeList = res.data;
        })
        .catch(() => {});
    },
  },
};
</script>

 <style scoped src="@/assets/css/page.css"></style>
<style lang="less" scoped>
.el-input-group {
  width: 603px;
  border-radius: 10px;
}
/deep/.el-input-group__append {
  background: #3892eb;
  color: #fff;
}
/deep/.el-tabs__header {
  padding: 0 43px;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: transparent;
}

/deep/.el-pager li,
/deep/.el-pagination .btn-next,
/deep/.el-pagination .btn-prev {
  background-color: #f7f4f4;
}
.el-table__row:hover p {
  color: #3892eb;
  cursor: pointer;
}
// 弹出框
.dialog {
  /deep/.el-dialog__body {
    padding: 20px 100px 50px;
  }
}
</style>